import * as React from 'react';
import { Field } from './Field';
import { TextArea as TextAreaStandard } from '@emorg-prd/standard-react';
import { IValidation } from '../../../utils/Validation';
import './Textarea.css'

export type TextAreaVariantState = "disabled" | "success" | "read-only" | "error";

export enum TextAreaState {
    Success = 'em-is-valid',
    Disabled = 'em-is-disabled',
    Error = 'em-has-error',
    ReadOnly = 'em-is-readonly'
}

const typeMap: Record<TextAreaVariantState, TextAreaState> = {
	'success': TextAreaState.Success,
	'disabled': TextAreaState.Disabled,
	'error': TextAreaState.Error,
	'read-only': TextAreaState.ReadOnly,
};

interface TextAreaProps extends Omit<React.ComponentProps<typeof TextAreaStandard>, 'state'|'onBlur'|'onFocus'> {
	onChange: (e: any) => void;
	className?: string;
	disabled?: boolean;
	state?: TextAreaState;
	validation: IValidation;
}

const Textarea: React.FC<TextAreaProps> = (props) => {
	const abstractTextArea = new (class extends Field<TextAreaProps> {
		constructor() {
			super({
				onChange: props.onChange,
				value: props.value,
				validation: props.validation,
			});
		}
	})();

	return (
		<TextAreaStandard
			{...props}
			optionalClass={props.className}
			state={props.disabled ? TextAreaState.Disabled : (!abstractTextArea.isValid() ? TextAreaState.Error : TextAreaState.Success)}
			note={abstractTextArea.nonValidMessage() || props.note}
		/>
	);
}

export { Textarea };
